var map = {
	"./wscn-icon-stack.vue": 280,
	"./wscn-icon-svg.vue": 281
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 305;


//////////////////
// WEBPACK FOOTER
// ./src/components/icon-svg nonrecursive \.vue$
// module id = 305
// module chunks = 25